import React, { createContext, useContext, useState } from 'react';

const PrivateLayoutContext = createContext(null);

export const PrivateLayoutProvider = ({ children }) => {
  const [bannerChildren, setBannerChildren] = useState(null);

  return (
    <PrivateLayoutContext.Provider
      value={{
        bannerChildren,
        setBannerChildren
      }}>
      {children}
    </PrivateLayoutContext.Provider>
  );
};

export const usePrivateLayout = () => {
  return useContext(PrivateLayoutContext);
};
